module.exports = __webpack_public_path__ + "static/img/preview_dashboard_kpis.935dfe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v7/preview_dashboard_kpis.jpg
// module id = L7fU
// module chunks = 0